
import { useEffect, useState } from "react";
import { Form, Input, Button, message } from 'antd';
import { post,get } from "../../../component/fetch"
import { encode } from 'js-base64';
import "./index.scss"
import { connect } from 'react-redux'
const { Search } = Input;
function SetPassword(props:any) {
    const [forgetForm] = Form.useForm()
    const [randomImgUrl, setRandomImgUrl] = useState('')
    const {goBack ,mobile,mobileDisabled,submit,sendCodeInterface} = props
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [passwordVisibleTwo, setPasswordVisibleTwo] = useState(false);
    /**设置密码确认回调 */
    function onFinish(val: any) {
        if (val.password !== val.confirmPassword) {
            message.error('两次密码输入不一致,请重新输入')
            return
        }
        // const { mobile, smsCode, password } = val
        const data = {...val}
        data.mobile = encode(data.mobile)
        data.smsCode = encode(data.smsCode)
        data.password = encode(data.password)
        submit(data)
        // post(`user/api/user/modifyPasswordWithUnify`, {
        //     mobile: encode(mobile),
        //     smsCode: encode(smsCode),
        //     password: encode(password)
        // }, true).then(res => {
        //     if (res.code === 0) {
        //         message.success(res.data)
        //         goBack()
        //     }
        // })
    }
    /**获取图形验证码 */
    const getRandomCode = async () => {
        return await fetch(`/main/ran/random`)
          .then(
            response => response.blob(),
            error => console.log('An error occurred.', error)
          )
          .then((blob: any) => {
            const randomImgUrl = window.URL.createObjectURL(blob)
            setRandomImgUrl(randomImgUrl)
          }
          )
      }
    /** 获取短信验证码事件*/
    const getSmsCode = () => {
        const mobile = forgetForm.getFieldValue("mobile")
        const randomCode = forgetForm.getFieldValue("randomCode")
        if (!mobile) {
            message.info('请填写手机号')
            return
        }
        if (!randomCode) {
            message.info('请填写图形验证码')
            return
        }
        post(`${sendCodeInterface || '/user/api/user/sendSmsCodeWithUnify'}`, {
            mobile: encode(mobile),
            randomCode: encode(randomCode),
            smsTitle: props.initData.smsTitle
        }, true).then(res => {
            message.success('短信成功发送')
        })
    }
    useEffect(()=>{
        getRandomCode()
    },[])
    return <>
        <h3 style={{ color: "#1677ff" }} color="#1677ff">设置密码</h3>
        <Form className="loginForm" form={forgetForm} onFinish={onFinish} initialValues={{mobile:mobile || ""}}>
            <Form.Item name="mobile" rules={[{ required: true, message: '请输入您的图形验证码' }]}>
                <Input  autoComplete="new-mobile" disabled={mobileDisabled || false} placeholder="请输入手机号"></Input>
            </Form.Item>
            <Form.Item
                name="randomCode"
                rules={[{ required: true, message: '请输入您的图形验证码' }]}
            >
                <Search
                    placeholder="请输入图形验证码"
                    className="searchInput"
                    enterButton={<img src={randomImgUrl} alt="验证码"  onClick={getRandomCode} />}
                    style={{ padding: '0' }}
                    size="large"
                />
            </Form.Item>
            <Form.Item
                name="smsCode"
                rules={[{ required: true, message: '请输入您的短信验证码' }]}
            >
                <Search
                    placeholder="请输入短信验证码"
                    className="searchInput"
                    enterButton={<Button type="primary"  onClick={getSmsCode}>获取验证码</Button>}
                    style={{ padding: '0' }}
                    size="large"
                />
            </Form.Item>
            <Form.Item name="password" rules={[{ required: true, pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*?[0-9])[a-zA-Z\d]{8,}$/, message: '密码长度8位以上,至少包含大小写和数字' }]}>
                <Input.Password visibilityToggle={{ visible: passwordVisible, onVisibleChange: setPasswordVisible }}   autoComplete="new-password" placeholder="请输入密码"></Input.Password>
            </Form.Item>
            <Form.Item  name="confirmPassword"   rules={[{ required: true, pattern:/^(?=.*[a-z])(?=.*[A-Z])(?=.*?[0-9])[a-zA-Z\d]{8,}$/, message: '密码长度8位以上,至少包含大小写和数字' }]}>
                <Input.Password visibilityToggle={{ visible: passwordVisibleTwo, onVisibleChange: setPasswordVisibleTwo }}   autoComplete="new-password" placeholder="请确认密码"></Input.Password>
            </Form.Item>
            <Form.Item>
                <Button style={{ marginRight: "20px" }} onClick={() => {
                    goBack()
                }}>后退</Button> <Button type="primary" htmlType="submit">确认</Button>
            </Form.Item>
        </Form>
    </>
}
const getInitData = (state: { initData: Array<any> }) => {
    return {
        initData: state.initData,
    };
};
export default connect(getInitData)(SetPassword)